export default {"src":"/_next/static/media/icon-disclaimer.13a8ae30.svg","height":14,"width":11,"blurWidth":0,"blurHeight":0};